import {useCallback} from 'react'

import useCvip from './useCvip'
import {useWallet} from 'use-wallet'

import {leave, getXCvipStakingContract} from '../cvip/utils'

const useLeave = () => {
  const {account} = useWallet()
  const cvip = useCvip()

  const handle = useCallback(
    async (amount: string) => {
      const txHash = await leave(
        getXCvipStakingContract(cvip),
        amount,
        account,
      )
      console.log(txHash)
    },
    [account, cvip],
  )

  return {onLeave: handle}
}

export default useLeave
